import { render, staticRenderFns } from "./AddNoteModal.vue?vue&type=template&id=0df09181&scoped=true&"
import script from "./AddNoteModal.vue?vue&type=script&lang=js&"
export * from "./AddNoteModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNoteModal.vue?vue&type=style&index=0&id=0df09181&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df09181",
  null
  
)

export default component.exports